import { render } from "./CardStretch.vue?vue&type=template&id=57d1d0d1"
import script from "./CardStretch.vue?vue&type=script&lang=ts"
export * from "./CardStretch.vue?vue&type=script&lang=ts"
script.render = render

export default script